/**
 * Get initials from a name
 * @param {string} name - The name to get initials from
 * @returns {string} - The initials (max 2 characters)
 */
export const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

/**
 * Generate a random room name
 * @returns {string} - A unique room name
 */
export const generateRoomName = () => {
  return `room-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export { showError, showSuccess, showMeetingBlocked, showNotice } from './notices';

